import React from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';

function Pictures({
    PicturesContent,
    LanguageSelected,
    t,
    ImageUrl,
    hashedUserId,
    FindPictureModal,
    setFindPictureModal,
    FindPictureId,
    setFindPictureId
    ,divstyle
}) {
    const responsive = {
        desktop: {
            breakpoint: { max: 3000, min: 1024 },
            items: 2,
        },
        tablet: {
            breakpoint: { max: 1024, min: 464 },
            items: 2,
        },
        mobile: {
            breakpoint: { max: 464, min: 0 },
            items: 2,
        },
    };
    return (
        <div>
            {PicturesContent && PicturesContent.length > 0 && (
                <>
                    <div className={`pt-5 pb-5 pl-3 pr-3  ${divstyle} `}>
                        <div className="">
                            <h1
                                className={`${LanguageSelected == 'ar'
                                        ? 'title title--h1 first-title title__separate text-theme right-2.5'
                                        : 'title left-2 title--h1 first-title title__separate text-theme'
                                    }`}
                            >
                                {t("Images")}
                            </h1>
                        </div>
                        <div className="pr-2 pt-6 pb-3">
                            <div className="grid grid-cols-1 -mt-2">
                                <div className="" />
                                <Carousel className='font-sm -mt-2' responsive={responsive}>
                                    {PicturesContent.map((image, index) => (
                                        <div
                                            key={index}
                                            className="gallery-grid__image-wrap relative"
                                        >
                                            <img
                                                className="gallery-grid__image cover ml-2 lazyload"
                                                src={`${ImageUrl}/${hashedUserId}/${image.Image}`}
                                                data-zoom
                                                alt=""
                                                onClick={() => {
                                                    setFindPictureModal(true);
                                                    setFindPictureId(image.id);
                                                }}
                                            />
                                        </div>
                                    ))}
                                </Carousel>
                            </div>
                        </div>
                    </div>
                    {FindPictureModal &&
                        PicturesContent.map((picture) => {
                            if (picture.id == FindPictureId) {
                                return (
                                    <div
                                        className="fixed z-1000 left-0 top-0 flex h-full w-screen items-center justify-center bg-black bg-opacity-50 py-10"
                                        key={picture.id}
                                    >
                                        <div className="relative max-h-screen findservice overflow-hidden">
                                            <div className="absolute top-4 right-0 p-4">
                                                <a
                                                    className='w-12 h-12 '
                                                    onClick={() => {
                                                        setFindPictureModal(false);
                                                        setFindPictureId(null);
                                                    }}
                                                >
                                                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-white div-sections opacity-50 rounded-xl cursor-pointer"
                                                        viewBox="0 0 20 20" fill="currentColor">
                                                        <path fillRule="evenodd" d="M14.707 14.707a1 1 0 0 1-1.414 0L10 11.414l-3.293 3.293a1 1 0 1 1-1.414-1.414L8.586 10l-3.293-3.293a1 1 0 0 1 1.414-1.414L10 8.586l3.293-3.293a1 1 0 0 1 1.414 1.414L11.414 10l3.293 3.293a1 1 0 0 1 0 1.414z" />
                                                    </svg>
                                                </a>
                                            </div>
                                            <div className='w-full pl-3 pr-3 h-72 mx-auto'>
                                                <img
                                                    className="cover w-full h-full preview-image   rounded-xl mt-4"
                                                    src={`${ImageUrl}/${hashedUserId}/${picture.Image}`}
                                                    alt="Mountain"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                );
                            }
                        })}
                </>
            )}
        </div>
    );
}

export default Pictures;
